import { TabsWrapper, WrapperAvatar } from 'features/Clients/ui/style'
import { Tab, Tabs } from 'shared/components/Tabs'
import { UpdateAvatarForm } from 'features/Clients/ui/components/UpdateAvatarForm'
import { StyledLine } from 'shared/styles/GlobalStyle'
import { WrapperFormRow } from 'shared/components/WrapperFormRow'
import {
    FormDataDocumentsPersonal,
    FormDataFioPersonal,
    FormDataGeneralPersonal,
    FormDataPlacePersonal,
} from 'features/Clients/model/formData'
import { FormikInput } from 'shared/components/FormikInput'
import { Certificates } from 'entities/certificates'
import { UploadFile } from 'entities/uploadFiles'
import { OrdersTable } from 'features/Clients/ui/ordersTable'
import { Form } from 'formik'
import { FC } from 'react'
import { Counterparty } from 'entities/counterparties/model'
import { useParseCounterparty } from 'features/Clients/model/useParseCounterparty'
import { useParams } from 'react-router-dom'
import { IPropsFile } from 'features/Clients/types'

interface PersonalProfileFormProps {
    isEditable: boolean
    counterparty?: Counterparty
    setPhoto: (file: File | null) => void
    setNewFiles: (newFiles: IPropsFile[]) => void
    setRemovedFiles: (removedFiles: IPropsFile[]) => void
}

export const PersonalProfileForm: FC<PersonalProfileFormProps> = ({
    isEditable,
    counterparty,
    setPhoto,
    setNewFiles,
    setRemovedFiles,
}) => {
    const { id } = useParams()

    const { isCompany, counterpartyProfilePhoto, counterpartyName } =
        useParseCounterparty(counterparty)

    return (
        <Form>
            <TabsWrapper>
                <Tabs>
                    <Tab label='Профиль'>
                        <WrapperAvatar>
                            <UpdateAvatarForm
                                isEditable={isEditable}
                                isCompany={isCompany}
                                photo={counterpartyProfilePhoto}
                                name={counterpartyName}
                                updatePhoto={setPhoto}
                            />
                        </WrapperAvatar>
                        <StyledLine margin='20px 0' />
                        {isEditable && (
                            <WrapperFormRow
                                title='ФИО'
                                formData={FormDataFioPersonal.map(row =>
                                    row.map(item => ({
                                        ...item,
                                        disabled:
                                            item.name === 'created_at'
                                                ? true
                                                : !isEditable,
                                        placeholder: isEditable
                                            ? item.placeholder
                                            : '',
                                    })),
                                )}
                            />
                        )}
                        <WrapperFormRow
                            title='Общие данные'
                            formData={FormDataGeneralPersonal.map(row =>
                                row.map(item => ({
                                    ...item,
                                    disabled:
                                        item.name === 'created_at'
                                            ? true
                                            : !isEditable,
                                    placeholder: isEditable
                                        ? item.placeholder
                                        : '',
                                })),
                            )}
                        >
                            {counterparty && counterparty.isBlackList && (
                                <div className='row'>
                                    <FormikInput
                                        name='comment'
                                        label='Комментарий'
                                        placeholder={
                                            isEditable ? 'Комментарий' : ''
                                        }
                                        className='inputForm'
                                        disabled={!isEditable}
                                        $afterIcon='clearInput'
                                    />
                                </div>
                            )}
                        </WrapperFormRow>
                        <Certificates counterparty_id={id} />
                    </Tab>
                    <Tab label='Документы'>
                        <>
                            <WrapperFormRow
                                title='Документы'
                                formData={FormDataDocumentsPersonal.map(row =>
                                    row.map(item => ({
                                        ...item,
                                        disabled:
                                            item.name === 'created_at'
                                                ? true
                                                : !isEditable,
                                        placeholder: isEditable
                                            ? item.placeholder
                                            : '',
                                    })),
                                )}
                            >
                                <div className='row'>
                                    <UploadFile
                                        file={(counterparty?.documentPhotos ?? []).map(
                                            photo =>
                                                ({
                                                    hash_name: photo?.hashName,
                                                    read_url: photo?.readUrl,
                                                    file_name: photo?.fileName,
                                                }) as any,
                                        )}
                                        disabled={isEditable}
                                        onNewFilesChange={setNewFiles}
                                        onRemovedFilesChange={setRemovedFiles}
                                    />
                                </div>
                            </WrapperFormRow>
                            <WrapperFormRow
                                title='Место прописки'
                                formData={FormDataPlacePersonal.map(row =>
                                    row.map(item => ({
                                        ...item,
                                        disabled:
                                            item.name === 'created_at'
                                                ? true
                                                : !isEditable,
                                        placeholder: isEditable
                                            ? item.placeholder
                                            : '',
                                    })),
                                )}
                            />
                        </>
                    </Tab>
                    <Tab label='История заказов'>
                        {id && <OrdersTable id={id} />}
                    </Tab>
                </Tabs>
            </TabsWrapper>
        </Form>
    )
}
